import { throwError } from 'rxjs';

export function mapResponseWithData(response : any)
{
    if (response && response.status) {
        if (response.status.code !== 0) {
            return throwError(response.status.message);
        }

        return response.data
    } else {
        return response;
    }
}
